import { DATE_FORMAT, FilterOperator, MetricView } from '@nemuru-eng/js-api-client';

import { CustomDate } from '../CustomDate';
import { QueryBuilder } from '../QueryBuilder';
import { TimeInterval } from '../TimeInterval';
import { MetricFilter } from './MetricFilter';

export class EndDateFilter extends MetricFilter<TimeInterval> {
  public field = 'end_date';
  public operator = FilterOperator.LTE;

  constructor(timeInterval: TimeInterval[]) {
    super(timeInterval);
  }

  public value(): string {
    return new CustomDate(this.values[0].current.end).formatDate(DATE_FORMAT.YYYY_MM_DD);
  }

  public needsRequest(newQueryBuilder: QueryBuilder): boolean {
    if (!this.values) return false;
    const newFilter = newQueryBuilder.filters.find((currentFilter) => this.field === currentFilter.field);
    if (!newFilter) return true;
    return (newFilter as EndDateFilter).values[0].current.end > this.values[0].current.end;
  }

  public merge(newFilter: EndDateFilter): this {
    if (!(newFilter instanceof EndDateFilter) || !newFilter.values) return this;
    if (this.values && newFilter.values[0].current.end <= this.values[0].current.end) return this;
    return new EndDateFilter([...newFilter.values]) as this;
  }

  public filterMetrics<K extends MetricView>(metrics: K[]): K[] {
    const endDate = this.values[0].current.end;
    return metrics.map((metricView) => ({
      ...metricView,
      metrics: metricView.metrics.map((metric) => ({
        ...metric,
        metricsByDate: metric.metricsByDate.filter((metricByDate) => metricByDate.date <= endDate),
      })),
    }));
  }
}
